import incomeRestService from '../services/income/IncomeRestService'
import IncomeDto from '../models/Income'

const getDefaultState = () => {
  return {
    incomes: [],
    filteredIncomes: [],
    dialogActived: false,
    selectedItem: {},
    defaultItem: IncomeDto,
    incomeNumberList: null
  }
}

const state = getDefaultState()

const getters = {
  getIncomes: state => state.incomes,
  isDialogActived: state => state.dialogActived,
  getSelectedItem: state => state.selectedItem,
  getDefaultItem: state => state.defaultItem,
  getFilteredIncomes: state => state.filteredIncomes,
  getIncomeNumberList: state => state.incomeNumberList
}

const actions = {
  async getIncomes (context) {
    try {
      let data = await incomeRestService.getIncomes()
      context.commit('setIncomes', data)
    } catch (error) {
      console.log('Error fetching incomes')
    }
  },
  async getIncomeNumberList (context) {
    try {
      let data = await incomeRestService.getIncomeNumberList()
      context.commit('setIncomeNumberList', data)
    } catch (error) {
      console.log('Error fetching income number list', error)
    }
  },
  async saveIncome (context, incomeInfo) {
    const isEdit = Number(incomeInfo.id) > 0
    let snackBarContent = {actived: true, message: `Entrada ${isEdit ? 'Modificada' : 'Agregada'} Exitosamente.`, color: 'success'}
    try {
      return await incomeRestService.saveIncome(incomeInfo)
    } catch (error) {
      const backendMessage = error.response?.data?.errorList || error.response?.data?.message
      snackBarContent = {
        actived: true,
        message: backendMessage || `Error ${isEdit ? 'Modificando' : 'Agregando'} Entrada.`,
        color: 'error'
      }
      throw error
    } finally {
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    }
  },
  async deleteIncome (context, id) {
    try {
      await incomeRestService.deleteIncome(id)
      context.commit('setSnackBarStatus', {actived: true, message: 'Entrada borrada.', color: 'success'}, {root: true})
    } catch (error) {
      context.commit('setSnackBarStatus', {
        actived: true,
        message: error.response?.data?.message || 'No se pudo borrar la entrada.',
        color: 'error'
      }, {root: true})
      throw error
    }
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
    if (!active) {
      context.commit('setSelectedItemAsDefaultItem')
    }
  },
  setSelectedItem (context, selectedItem) {
    context.commit('setSelectedItem', selectedItem)
  },
  filterItems (context, filters) {
    context.commit('filterIncomeLocally', filters)
  },
  async filterItemsByCommodityId (context, filters) {
    try {
      let data = await incomeRestService.filterItemsByCommodityId(filters)
      context.commit('filterIncome', data)
    } catch (error) {
      console.error('Error filtering incomes by commodity.', error)
    }
  },
  refreshFilteredIncomes (context) {
    context.commit('refreshFilteredIncomes')
  }
}

const mutations = {
  updateAnalysis (state, {incomeId, analysis}) {
    for (const income of [...state.incomes, ...state.filteredIncomes, state.selectedItem]) {
      if (Number(income?.id) === Number(incomeId)) income.analysis = analysis
    }
  },
  setIncomes (state, incomes) {
    state.incomes = incomes
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  },
  setSelectedItemAsDefaultItem (state) {
    state.selectedItem = state.defaultItem
  },
  filterIncome (state, data) {
    state.filteredIncomes = data
  },
  filterIncomeLocally (state, filters) {
    const normalized = value => String(value || '').trim().toLocaleLowerCase()
    state.filteredIncomes = state.incomes.filter(income => {
      const commodity = income.commodity || (Array.isArray(income.commodities) ? income.commodities[0] : null)
      const gramaje = Number(income.analysis?.gramaje ?? commodity?.gramaje ?? 0)
      return (!filters.originId || Number(income.origin?.id) === Number(filters.originId)) &&
        (!filters.ownerId || Number(income.waybillOwner?.id) === Number(filters.ownerId)) &&
        (!filters.grainTypeId || Number(commodity?.grainType?.id) === Number(filters.grainTypeId)) &&
        (!normalized(filters.numCP) || normalized(income.waybill).includes(normalized(filters.numCP))) &&
        (!normalized(filters.harvesting) || normalized(commodity?.harvesting).includes(normalized(filters.harvesting))) &&
        (!filters.gmgMin || gramaje >= Number(filters.gmgMin)) &&
        (!filters.gmgMax || gramaje <= Number(filters.gmgMax))
    })
  },
  refreshFilteredIncomes (state) {
    state.filteredIncomes = state.incomes
  },
  setIncomeNumberList (state, data) {
    state.incomeNumberList = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
